import React from "react";
import { motion } from "framer-motion";
import { useLenis } from "lenis/react";
import { Reveal } from "./Reveal";

const ITEMS = [
  { title: "Luxury Agent Relationships", sub: "For agents whose listings demand a flawless close." },
  { title: "Builder Relationships", sub: "Dedicated coordination for active build pipelines." },
  { title: "Commercial Introductions", sub: "Early conversations for upcoming commercial deals." },
  { title: "Investor Introductions", sub: "Discreet groundwork for portfolio transactions." },
];

export const Timeline = () => {
  const lenis = useLenis();
  return (
    <section className="relative bg-ink py-28 md:py-40 border-t border-charcoal/40" data-testid="timeline">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-14">
          <div className="lg:col-span-4">
            <Reveal><div className="overline mb-6">Now Accepting</div></Reveal>
            <Reveal delay={0.1}>
              <h2 className="font-serif font-light text-ivory text-5xl md:text-6xl leading-[1] tracking-tight">
                Early Partnership Requests
              </h2>
            </Reveal>
            <Reveal delay={0.2}>
              <button
                onClick={() => lenis?.scrollTo("#connect", { offset: -20, duration: 1.6 })}
                data-testid="timeline-connect-btn"
                className="mt-10 group text-gold text-[0.72rem] uppercase tracking-[0.2em] border-b border-gold/50 hover:border-gold pb-2 transition-colors duration-300"
              >
                Request an Introduction
                <span className="ml-3 inline-block transition-transform duration-300 group-hover:translate-x-1">→</span>
              </button>
            </Reveal>
          </div>

          <div className="lg:col-span-7 lg:col-start-6">
            {ITEMS.map((item, i) => (
              <Reveal key={item.title} delay={i * 0.08}>
                <motion.div
                  whileHover={{ x: 10 }}
                  transition={{ duration: 0.4 }}
                  className="group flex items-center gap-8 py-8 border-b border-charcoal/50"
                >
                  <span className="font-serif text-gold/70 text-lg w-10">{String(i + 1).padStart(2, "0")}</span>
                  <div className="flex-1">
                    <h3 className="font-serif text-2xl md:text-3xl text-ivory font-light">{item.title}</h3>
                    <p className="text-taupe text-sm font-light mt-2">{item.sub}</p>
                  </div>
                  <span className="text-gold opacity-0 -translate-x-2 transition-all duration-500 group-hover:opacity-100 group-hover:translate-x-0">→</span>
                </motion.div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
